import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {AdicionalComparacaoIfoodVM, ResolucaoAdicionalIfoodVM, SnapshotOpcaoCanalVendaVM} from './canais-venda.models';

@Component({
  selector: 'app-resolucao-adicional-ifood',
  templateUrl: './resolucao-adicional-ifood.component.html',
  styleUrls: ['./resolucao-adicional-ifood.component.scss']
})
export class ResolucaoAdicionalIfoodComponent implements OnChanges {
  @Input() dados: AdicionalComparacaoIfoodVM;
  @Input() desabilitado = false;
  @Output() escolher = new EventEmitter<ResolucaoAdicionalIfoodVM | null>();
  @Output() revisar = new EventEmitter<void>();
  acao = '';
  candidatoId = '';
  opcoes: {[id: number]: string} = {};

  ngOnChanges(changes: SimpleChanges): void {
    if(!changes.dados || !this.dados) return;
    this.acao = this.dados.local.idExterno ? 'VINCULAR' : this.dados.candidatos.length ? '' : 'NOVO';
    this.candidatoId = this.dados.local.idExterno || this.dados.candidatos[0]?.grupo.idExterno || '';
    this.troqueCandidato(false);
  }

  get candidato() { return this.dados.candidatos.find(it => it.grupo.idExterno === this.candidatoId); }

  troqueCandidato(interagiu = true): void {
    this.opcoes = {};
    for(const opcao of this.dados.local.opcoes)
      if(opcao.idExterno && this.candidato?.grupo.opcoes.some(it => it.idExterno === opcao.idExterno))
        this.opcoes[opcao.alvoLocalId] = opcao.idExterno;
    this.emita(interagiu);
  }

  emita(interagiu = true): void {
    if(interagiu) this.revisar.emit();
    const base = {grupoLocalId: this.dados.local.alvoLocalId};
    if(this.acao === 'NOVO') {this.escolher.emit({...base, acao: 'NOVO'}); return;}
    const selecionadas = Object.values(this.opcoes).filter(id => id && id !== 'NOVO');
    if(this.acao !== 'VINCULAR' || !this.candidato || new Set(selecionadas).size !== selecionadas.length ||
      this.dados.local.opcoes.some(opcao => !this.opcoes[opcao.alvoLocalId])) {
      this.escolher.emit(null); return;
    }
    this.escolher.emit({...base, acao: 'VINCULAR', grupoExternoId: this.candidatoId,
      opcoes: this.dados.local.opcoes.map(opcao => this.opcoes[opcao.alvoLocalId] === 'NOVO'
        ? {opcaoLocalId: opcao.alvoLocalId, acao: 'NOVO'}
        : {opcaoLocalId: opcao.alvoLocalId, acao: 'VINCULAR', opcaoExternaId: this.opcoes[opcao.alvoLocalId]})});
  }

  usada(id: string, localId: number): boolean {
    return this.dados.local.opcoes.some(it => it.alvoLocalId !== localId && this.opcoes[it.alvoLocalId] === id);
  }

  correspondente(local: SnapshotOpcaoCanalVendaVM): SnapshotOpcaoCanalVendaVM | undefined {
    return this.candidato?.grupo.opcoes.find(it => it.idExterno === this.opcoes[local.alvoLocalId]);
  }

  difere(local: SnapshotOpcaoCanalVendaVM): boolean {
    const remota = this.correspondente(local);
    return !!remota && ['nome', 'codigoPdv', 'preco', 'disponivel'].some(campo => local[campo] !== remota[campo]);
  }

  valorRemoto(campo: string): string {
    if(!this.candidato || this.candidato.naoInformados.includes(campo)) return 'Não informado';
    const valor = this.candidato.grupo[campo];
    return typeof valor === 'boolean' ? (valor ? 'Sim' : 'Não') : String(valor);
  }

  statusRemoto(opcao: SnapshotOpcaoCanalVendaVM): string {
    return this.candidato.naoInformados.includes('opcao:' + opcao.idExterno + ':disponivel')
      ? 'Não informado' : opcao.disponivel ? 'Disponível' : 'Indisponível';
  }
}
